import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';
import { ActivityTemplate } from '../../activity-tracking/models';

const API_BASE = environment.TIMELINE_BASE;
const ACTIVITY_TRACKING_BASE = environment.ACTIVITY_TRACKING_BASE;

@Injectable()
export class RelatedTemplatesService {
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  getRelatedTemplates(task_template_id: number) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/related-tasks-template/${task_template_id}`,
    );
  }

  getRelatedActivityTemplates(task_template_id: number) {
    return this.http.get<any>(
      `${ACTIVITY_TRACKING_BASE}/companies/${this.companyId}/related-activity-template/autocomplete/${task_template_id}?size=50&search_term=`,
    );
  }

  addRelatedTemplate(task_template_id, related_task_template_id): Observable<any[]> {
    return this.http.post<any>(
      `${API_BASE}/companies/${this.companyId}/related-tasks-template/${task_template_id}/task-template/${related_task_template_id}`,
      '',
    );
  }
  addRelatedActivityTemplate(task_template_id, related_activity_template_id): Observable<any[]> {
    return this.http.post<any>(
      `${ACTIVITY_TRACKING_BASE}/companies/${this.companyId}/related-activity-template/task-template/${task_template_id}/activity-template/${related_activity_template_id}`,
      '',
    );
  }

  deleteRelatedTemplate(task_template_id, related_task_template_id) {
    return this.http.delete<any>(
      `${API_BASE}/companies/${this.companyId}/related-tasks-template/${task_template_id}/task-template/${related_task_template_id}`,
    );
  }

  deleteRelatedActivityTemplate(task_template_id, related_activity_template_id) {
    return this.http.delete<any>(
      `${ACTIVITY_TRACKING_BASE}/companies/${this.companyId}/related-activity-template/task-template/${task_template_id}/activity-template/${related_activity_template_id}`,
    );
  }

  searchTemplates(task_template_id, term) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/related-tasks-template/autocomplete/${task_template_id}?search_term=${term}`,
    );
  }

  searchActivityTemplates(searchTerm: string): Observable<{ data: ActivityTemplate[] }> {
    return this.http.get<{ data: ActivityTemplate[] }>(
      `${ACTIVITY_TRACKING_BASE}/companies/${this.companyId}/templates/autocomplete?size=50&search_term=${searchTerm}&is_active=true`,
    );
  }
}
